import { MyContext } from "@/store/myContext";
import React, { useContext } from "react";
import { DataBox } from "./DataBox";
import { PageHeader } from "./PageHeader";

export default (props) => {
    const { state } = useContext(MyContext);

    return (
        <>
            {state.activeMenu === "baseVehicle" && <>
                <PageHeader />
                <DataBox {...props} />
            </>}
        </>
    )
}